<template>
  <div class="app-wrapper">
    <div id="app"
      :class="$route.name"
    >
      <transition name="page">
        <router-view
          :bg-image="`${publicPath}/img/downloading.png`"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import 'browser-report'
import Vue from 'vue'
import AuthService from 'Core/src/auth/authService'

Vue.use(AuthService)
Vue.prototype.$eventHub = new Vue()

export default {
  name: 'app',

  data () {
    return {
      publicPath: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
  background-size: cover;
  background-position: center center;
  min-width: 100vw;

  &.not-found {
    background-color: #F5F4F0;
    height: 100vh;
    display: flex;
  }
}

.app-wrapper {
  min-height: 100vh;
}

</style>
